import { CustomCellEditorProps } from "ag-grid-react";
import { Select } from "antd";
import { LocationSearchNotFoundMessages } from "components/widgets/location-search-not-found-messages";
import { useShippingLocation } from "hooks/material";
import { useEffect, useMemo, useState } from "react";

type Props = CustomCellEditorProps;

function ShippingLocationCellEditor(props: Props) {
  const { stopEditing, context, data, onValueChange } = props;

  const { gqlClientForProject, tokenRetrievalState } = context;

  const [selectValue, setSelectValue] = useState<any>({
    label: data?.shipping_location?.label,
    value: data?.shipping_location?.place_id
  });

  const {
    searchLocation,
    fetching,
    selectOptions: shippingLocationOptionResults,
    searchedString
  } = useShippingLocation({
    gqlClientForProject,
    projectToken: tokenRetrievalState?.token
  });

  useEffect(() => {
    if (data.shipping_location?.place_id) {
      setSelectValue({
        label: data?.shipping_location?.label,
        value: data?.shipping_location?.place_id
      });
    }
  }, [data]);

  const shippingLocationOptions = useMemo(() => {
    if (!searchedString && data.shipping_location?.place_id) {
      return [
        {
          label: data?.shipping_location?.label,
          value: data?.shipping_location?.place_id
        }
      ];
    }
    return shippingLocationOptionResults;
  }, [data, shippingLocationOptionResults, searchedString]);

  return (
    <div className="w-full !h-full flex items-center">
      <Select
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        defaultOpen
        placeholder="Search by Address, City or State"
        onSearch={searchLocation}
        allowClear
        loading={fetching}
        options={shippingLocationOptions}
        notFoundContent={
          <LocationSearchNotFoundMessages
            searchedString={searchedString}
            fetching={fetching}
          />
        }
        showSearch
        filterOption={false}
        labelInValue
        onClear={() => {
          onValueChange({
            label: "",
            value: null
          });

          setTimeout(() => {
            stopEditing();
          });
        }}
        onChange={(selection: any) => {
          if (!selection) return;
          onValueChange({
            label: selection.label,
            value: selection.value
          });

          setTimeout(() => {
            stopEditing();
          });
        }}
        value={!searchedString ? selectValue : null}
        className="w-full"
      />
    </div>
  );
}

export default ShippingLocationCellEditor;
